import cortanaComposeStore from '../store/cortanaComposeStore';
import { mutatorAction } from 'satcheljs';

export default mutatorAction('clearResults', function clearResults() {
    const viewState = cortanaComposeStore.viewState;
    for (const key of viewState.resultsShown.keys()) {
        viewState.resultsShown.set(key, []);
    }
    viewState.hasSelectableElement = false;
});
